<template>
  <router-view></router-view>
</template>
<script>
  export default {
    name: 'BusinessList'
  }
</script>



// WEBPACK FOOTER //
// src/components/services/sbp/BusinessesList.vue